<template>
    <div class="pt-4 px-4">
        <div class="title-container col-12">
            <div v-if="value" class="title-content">
                <div>
                    <i :class="icon" class="icon-content border border-2 p-4 rounded-circle"></i>
                </div>
                <div>
                    <div>
                        <span class="title">{{ title }}</span>
                        <i
                            :title="`Bloco ${title}`"
                            v-b-popover.hover.bottom="description"
                            class="info-content fas fa-info-circle"
                        ></i>
                    </div>
                    <div class="progress-container">
                        <ProgressBar
                            class="progress-bar"
                            :value="performanceBlock == null ? 0 : performanceBlock"
                            height=".7rem"
                            :label="viewBlockPerformance(performanceBlock)"
                            :labelColor="updateColorPerformance(performanceBlock)"
                            :color="updateColorPerformance(performanceBlock)"
                            :max="maxProgressBar"
                        ></ProgressBar>
                        <span>{{ viewBlockPerformance(performanceBlock) }}</span>
                    </div>
                </div>
            </div>
            <div>
                <router-link
                    v-if="isCurrentUserVisible && isBlockWithAttributes"
                    :to="`/v2/strategy/onepage/permission-access?blockId=${blockId}`"
                    class="button-setting"
                    :disabled="false"
                >
                    <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path :d="svg" fill="#3B3F4E" />
                    </svg>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import ProgressBar from '@/views/components/progress-bar/ProgressBar.vue'
import { headerSvg } from './pathSvg'
export default {
    name: 'HeaderAttribute',
    components: {
        ProgressBar,
    },
    props: {
        blockId: Number,
        title: String,
        description: String,
        icon: String,
        performanceBlock: Number,
        value: Boolean,
    },
    data() {
        return {
            maxProgressBar: 1,
            svg: headerSvg,
        }
    },
    computed: {
        ...mapState('strategy', {
            blocks: (state) => state.blocks,
        }),
        isCurrentUserVisible() {
            const types = ['local_administrator', 'administrator', 'god']
            return types.includes(this.$store.getters.getCurrentUser.role.name)
        },
        isBlockWithAttributes() {
            return this.blocks.find((block) => {
                if (block.id == this.blockId) {
                    return block.attributes.length != 0
                }
            })
        },
    },
    methods: {
        viewBlockPerformance(performanceBlock) {
            let valuePerformance = (performanceBlock * 100).toFixed(0)
            return `${valuePerformance}%`
        },
        updateColorPerformance(performanceBlock) {
            return !performanceBlock
                ? '#BEC0C0'
                : performanceBlock < 0.3
                ? '#f05050'
                : performanceBlock < 0.7
                ? '#fad732'
                : '#27c24c'
        },
    },
}
</script>

<style lang="sass" scoped>
.button-setting
    font-size: 1.4rem
    padding: 0
    border: none
    &:hover
    background-color: transparent
    &:active
    border: none
.title-container
    display: flex
    justify-content: space-between
    padding: 0 !important
    .title-content
        display: flex
        align-items: center
        .title
            font-size: 1.5rem
            font-weight: bold
            color: #3B3F4E
            margin-right: 0.5rem
        .icon-content
            color: #009ADA
            font-size: 2.7rem
            border-color: #009ADA !important
            margin-right: 1rem
        .info-content
            cursor: pointer
            color: #bec0c0
.progress-container
    display: flex
    justify-content: flex-start
    align-items: center
    column-gap: .5rem
    span
        color: #6E6E6E
    .progress-bar
        background: #BEC0C0 !important
        min-width: 200px
</style>
